import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import useBusinessStore from '../state/businessStore';

import SupportIcon from '../assets/icons/Support.svg';
import SearchIcon from '../assets/icons/Search.svg';
import Graphics from '../assets/Home-emptyState.png';
import BriefcaseIcon from '../assets/icons/briefcase.svg';
import ConnectChannelIcon from '../assets/icons/ConnectChannel.svg';
import TroublesIcon from '../assets/icons/life-buoy.svg';
import CheckIcon from '../assets/icons/Check-Green.svg';

import CreateBusinessModal from '../partials/business/CreateBusinessModal';
import LayoutHeader from '../partials/LayoutHeader';

import './HomeEmptyState.scss';

const HomeEmptyState = () => {
  const { t } = useTranslation('homeEmpty');
  const navigate = useNavigate();

  //:: State management with Zustand
  const {
    businesses,
    isChannelConnected,
    setIsChannelConnected,
    setAllowRedirect,
  } = useBusinessStore();

  // State management
  const [showModal, setShowModal] = useState(false);

  const handleCreateBusiness = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConnectChannel = () => {
    setIsChannelConnected(true);

    setTimeout(() => {
      Swal.fire({
        title: t('congratulations_title'),
        text: t('congratulations_message'),
        icon: 'success',
        confirmButtonText: t('confirm_button_text'),
      }).then(() => {
        setAllowRedirect(true);
        navigate('/business-admin', { replace: true });
      });
    }, 1250);
  };

  // Verify if at least one business has been created
  const isBusinessCreated = businesses.length > 0;

  // Reset isChannelConnected if no business exists (triggered when returning to HomeEmptyState)
  useEffect(() => {
    if (!isBusinessCreated) {
      setIsChannelConnected(false);
    }
  }, [isBusinessCreated, setIsChannelConnected]);

  return (
    <>
      <LayoutHeader title={t('title')} languageToggleActive />

      <div className="home-empty-state">
        <div className="home-empty-state__hero">
          <img src={Graphics} alt="SaaS graphics picture" />
        </div>
        <div className="home-empty-state__content">
          <div className="home-empty-state__texts">
            <p className="texts__welcome">{t('welcome_message')}</p>
            <h1 className="texts__title">{t('get_started_title')}</h1>
            <p className="texts__subtitle">{t('get_started_subtitle')}</p>
          </div>

          <div className="home-empty-state__actions">
            <div
              className={`home-empty-state__actions-first ${
                isBusinessCreated ? 'completed' : ''
              }`}
            >
              <span className="icon-wrapper">
                <img
                  src={isBusinessCreated ? CheckIcon : BriefcaseIcon}
                  alt="Create business icon"
                />
              </span>
              <div className="home-empty-state__actions-texts">
                <p className="texts__action-title">
                  {t('create_business_title')}
                </p>
                <p className="texts__action-subtitle">
                  {t('create_business_subtitle')}
                </p>
              </div>
              <button
                className={`home-empty-state__actions-button ${
                  isBusinessCreated ? 'button-success' : ''
                }`}
                onClick={handleCreateBusiness}
                disabled={isBusinessCreated}
              >
                {' '}
                {isBusinessCreated
                  ? t('business_created')
                  : t('create_business_button')}
              </button>
              {/* Modal form */}
              <CreateBusinessModal
                isOpen={showModal}
                onClose={handleCloseModal}
              />
            </div>
            <div
              className={`home-empty-state__actions-second ${
                isChannelConnected ? 'completed' : ''
              }`}
            >
              <span className="icon-wrapper">
                <img
                  src={isChannelConnected ? CheckIcon : ConnectChannelIcon}
                  alt="Connect channel icon"
                />
              </span>
              <div className="home-empty-state__actions-texts">
                <p className="texts__action-title">
                  {t('connect_channel_title')}
                </p>
                <p className="texts__action-subtitle">
                  {t('connect_channel_subtitle')}
                </p>
              </div>
              <button
                className={`home-empty-state__actions-button ${
                  isChannelConnected ? 'button-success' : ''
                }`}
                onClick={handleConnectChannel}
                disabled={!isBusinessCreated || isChannelConnected}
              >
                {' '}
                {isChannelConnected
                  ? t('channel_connected')
                  : t('connect_channel_button')}
              </button>
            </div>
          </div>

          <div className="home-empty-state__troubles">
            <img src={TroublesIcon} alt="Trouble icon" />
            <p>{t('troubles_message')}</p>
            <a href="#">{t('contact_us')}</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeEmptyState;
